// Lightweight dev-only logger.
// Wraps console.warn so production builds stay quiet without us having to
// remove every diagnostic call-site by hand. Use for graceful-degradation
// warnings (e.g. background fetches that fail silently in the UI).
export function warn(...args) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
}
